module.exports = __webpack_public_path__ + "img/document.0597a35b.svg";